export default __webpack_public_path__ + "static/media/pression.c3b75f96.svg";